<ss-modal [open]="true">
  <svg
    closeButton
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-4 h-4 text-white"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
  <div
    class="grid grid-cols-1 md:grid-cols-2 items-center rounded-lg md:max-w-4xl"
  >
    <div class="w-full h-64 rounded-t-lg md:h-[100%] md:rounded-l-lg relative">
      <ss-www-image-with-loader
        class="object-cover h-full w-full rounded-t-lg md:rounded-r-none md:rounded-l-lg"
        [fileDetail]="modalData.promoImage"
        desktopImageSize="half"
      ></ss-www-image-with-loader>
    </div>
    <div
      class="px-6 py-6 md:py-14"
      [ssDirectus]="{
        collection: 'promoModal',
        item: modalData.id,
        fields: ['promoText', 'promoButtonLink'],
      }"
    >
      <div class="mb-4" [innerHTML]="modalData.promoText"></div>
      <div
        class="mt-5"
        [ngClass]="{
          'w-1/2 lg:w-2/5': modalData.promoButtonLink.length === 1,
        }"
      >
        @for (
          button of modalData.promoButtonLink;
          track buttons($index, button)
        ) {
          <ss-building-block-button-link
            [buttonLink]="button.item"
          ></ss-building-block-button-link>
        }
      </div>
    </div>
  </div>
</ss-modal>
